import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService, Role } from '../../Services/auth.service';
import { UserRound, ChevronDown, Menu, LogOut, User } from 'lucide-react';
import './Header.css';

function Header() {
  const navigate = useNavigate();
  const user = authService().currentUser() || null;
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    if (user) {
      authService().logout();
    }
    navigate('/login');
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <header>
      <nav className="navbar">
        <div className="navcontainer">
          {/* Logo */}
          <img
            className="logo"
            src="/img/logo.png"
            alt="Logo"
          />

          {/* Hamburger menu button for small screens */}
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <Menu size={28} />
          </button>

          {/* Navigation items */}
          <div className={`navcontainerHeader ${menuOpen ? 'active' : ''}`}>
            <ul className="ul-header">
              {user ? (
                <>
                  {user.rol === Role.Leerkracht && (
                    <>
                      <li className="li-header">
                        <Link className="link-text" to="/leerkracht">Menu</Link>
                      </li>
                      <li className="li-header">
                        <Link className="link-text" to="/leerkracht/geplandelessen">Geplande lessen</Link>
                      </li>
                      <li className="li-header">
                        <Link className="link-text" to="/leerkracht/geschiedenis">Geschiedenis</Link>
                      </li>
                    </>
                  )}

                  {[Role.Besteller, Role.Gebruikersbeheerder].includes(user.rol) && (
                    <li className="li-header">
                      <Link className="link-text" to="/admin/configuratie/klastype">Configuratie</Link>
                    </li>
                  )}
                  
                  {[Role.Besteller, Role.Gebruikersbeheerder].includes(user.rol) && (
                    <li className="li-header">
                      <Link className="link-text" to="/admin/bestelling/controlevoorstel">Bestelling</Link>
                    </li>
                  )}

                  {/* Account dropdown */}
                  <li className="li-header">
                    <div className="dropdown" ref={dropdownRef}>
                      <button onClick={toggleDropdown} className="dropdown-btn">
                        <UserRound size={18} />
                        <span>{user.naam}</span>
                        <ChevronDown size={16} />
                      </button>

                      {dropdownOpen && (
                        <div className="dropdown-content">
                          <Link to="/profiel" onClick={() => setDropdownOpen(false)} className="menu-item">
                            <User size={16} />
                            <span>Profiel</span>
                          </Link>
                          <Link to="/login" onClick={() => { handleLogout(); setDropdownOpen(false); }} className="menu-item">
                            <LogOut size={16} />
                            <span>Uitloggen</span>
                          </Link>
                        </div>
                      )}
                    </div>
                  </li>
                </>
              ) : (
                <li className="li-header">
                  <Link className="link-text" to="/login">Login</Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;